import { HowWorkCard } from './HowWorkCard'
import { howWorkMock } from './howWorkMock'

// список карточек в блоке "как это работает?"
export function HowWorkList() {
  return (
    <>
      {howWorkMock.map(item => (
        <HowWorkCard {...item} key={item.num} />
      ))}
    </>
  )
}
